import { render, staticRenderFns } from "./SelectUikExportParamsDlg.vue?vue&type=template&id=6564d328"
import script from "./SelectUikExportParamsDlg.vue?vue&type=script&lang=js"
export * from "./SelectUikExportParamsDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports